import script from "./message.vue?vue&type=script&lang=ts&setup=true"
export * from "./message.vue?vue&type=script&lang=ts&setup=true"

import "./message.vue?vue&type=style&index=0&id=696ee2e0&lang=stylus&scoped=true"

import exportComponent from "D:\\Front-end-project\\anxin-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-696ee2e0"]])

export default __exports__